import { projectContext } from '@/layouts/MainLayout'
import { createProjectTask, createSubTask, editTask } from '@/services/task/task'
import { Input, InputRef, Space } from 'antd'
import { memo, useContext, useEffect, useRef, useState } from 'react'

export default memo(function TaskName(props: any) {
  const { task, editable = true, onSuccess, onCancel } = props
  const { projectType, projectId } = useContext(projectContext)
  const inputRef = useRef<InputRef>(null)
  const [editing, setEditing] = useState(props.editing || false)
  const [value, setValue] = useState<string>()

  useEffect(() => {
    setValue(task.name)
  }, [task])

  useEffect(() => {
    inputRef.current?.focus()
  }, [inputRef])

  const handleInputBlur = async (e) => {
    const value = e.target.value.trim()
    if (value) {
      let data
      if (task.id === -1) {
        if (task.parentId) {
          data = await createSubTask(task.parentId, { name: value })
        } else {
          data = await createProjectTask(projectType, projectId, { name: value })
        }
        onSuccess?.(data)
      } else {
        data = await editTask(task.id, { name: value })
        onSuccess?.(data)
      }
      setValue(value)
      setEditing(false)
    } else {
      onCancel?.(task.id)
    }
  }

  if (editing) {
    return <Input ref={inputRef} value={value} onChange={(e) => setValue(e.target.value)} onBlur={handleInputBlur} />
  }

  return (
    <Space
      onClick={() => {
        if (editable) {
          setEditing(true)
        }
      }}
    >
      {value}
    </Space>
  )
})
